import ChipInput from './ChipInput';
import EmailInput from './EmailInput';
import Filter from '../Filter/components/FilterButton';
import InputWithLabel from './InputWithLabel';
import LanguageDropdown from './LanguageDropdown';
import RangeSlider from './RangeSlider';
import PhoneNumberInput from './PhoneNumberInput';
import SelectInput from './SelectInput';
import TextAreaInput from './TextAreaInput';
import TextInput from './TextInput';
import UserAccount from './UserAccount';
import CategorySort from '../Sort/CategorySort';
import CampaignCategorySort from './CampaignCategorySort';

function UserInput(props) {
  const { type, ...rest } = props;

  switch (type) {
    case 'dropdown':
      return <LanguageDropdown {...rest} />;
    case 'user-account':
      return <UserAccount {...rest} />;
    case 'filter':
      return <Filter {...rest} />;
    case 'category-sort':
      return <CategorySort {...rest} />;
    case 'campaign-category-sort':
      return <CampaignCategorySort {...rest} />;
    case 'range-slider':
      return <RangeSlider {...rest} />;
    case 'input-with-label':
      return <InputWithLabel {...rest} />;
    case 'phone-number-input':
      return <PhoneNumberInput {...rest} />;
    case 'email-input':
      return <EmailInput {...rest} />;
    case 'text-input':
      return <TextInput {...rest} />;
    case 'text-area-input':
      return <TextAreaInput {...rest} />;
    case 'select-input':
      return <SelectInput {...rest} />;
    case 'chip-input':
      return <ChipInput {...rest} />;
    default:
      return '';
  }
}

export default UserInput;
